/* CUSTOM JS */

$(document).ready(function() {
    $('input[name=Color]').each(function() {
        $(this).on('click', function(){
            var color = $(this).val().toLowerCase().replace(' ','-');
            if($('.'+color).length > 0) {
                $('.product__media-list li').hide();
                //$('.product__media-list li.is-active.product__media-item--variant').hide();
                $('.product__media-list').find('.'+color).show();
                //$('.product__media-list li.is-active').show();
            }
        });
    });

    $('.variant-color-sec.button_image').each(function() {
        $(this).on('click', function(){
            $('.variant-color-sec.button_image').removeClass('active');
            $(this).addClass('active');
        });
    });

    $('.keys-section .per-key-wrapper').each(function() {
        $(this).on('click', function(){
            
            if(!$(this).hasClass('active')) {
                $('.keys-section .per-key-wrapper').removeClass('active');
                $(this).addClass('active');
            } else {
                $(this).removeClass('active');
                $(this).find('.per-key-details').hide();
            }
        });
    });
});

$(window).on('resize',function() {
    if(window.innerWidth > 749)
        $('.keys-section .per-key-wrapper .per-key-details').attr('style','');
});
